// extracted by mini-css-extract-plugin
export default {"headerTitle":"product_headerTitle__5gqfv","deletedLabel":"product_deletedLabel__KAmXh","page":"product_page__Bmd0T","header":"product_header__uR5Ht"};